import {createAction, props} from '@ngrx/store';
import {HttpErrorResponse} from '@angular/common/http';
import {DahLoadingType} from '@common/components-module/core-components.models';
import {DahPaginationModel} from '@common/models/commonHTTP.models';
import {WagePayment, WagePaymentSearchParams} from '@accounting/_common/models/wage-payment.models';

export const CheckState = createAction(
    '[WagePayments] Check State',
    props<{ payload: { modalView: boolean, close: boolean, items: WagePayment[] } }>()
);

export const CheckStateSuccess = createAction(
    '[WagePayments] Check State Success',
    props<{ payload: { modalView: boolean, close: boolean, items: WagePayment[] } }>()
);

export const LoadList = createAction(
    '[WagePayments] Load List',
    props<{ payload: { loading: DahLoadingType, clearState: boolean } }>()
);

export const LoadListSuccess = createAction(
    '[WagePayments] Load List Success',
    props<{ payload: { items: WagePayment[], pagination: DahPaginationModel, clearState: boolean } }>()
);

export const LoadListFailure = createAction(
    '[WagePayments] Load List Failure',
    props<{ payload: HttpErrorResponse }>()
);

export const SetPagination = createAction(
    '[WagePayments] Set Pagination',
    props<{ payload: boolean }>()
);

export const SetFilter = createAction(
    '[WagePayments] Set Filter',
    props<{ payload: WagePaymentSearchParams }>()
);

export const SetLoading = createAction(
    '[WagePayments] Set Loading',
    props<{ payload: DahLoadingType }>()
);

export const SetItemsLoading = createAction(
    '[WagePayments] Set Items Loading',
    props<{ payload: { id: string, isStart: boolean } }>()
);

export const UpdateItemSuccess = createAction(
    '[WagePayments] Update Item Success',
    props<{ payload: WagePayment }>()
);

export const DeleteItem = createAction(
    '[WagePayments] Delete Item',
    props<{ payload: WagePayment }>()
);

export const DeleteItemSuccess = createAction(
    '[WagePayments] Delete Item Success',
    props<{ payload: WagePayment }>()
);

export const DeleteItemFailure = createAction(
    '[WagePayments] Delete Item Failure',
    props<{ payload: WagePayment }>()
);

export const SetInitialState = createAction(
    '[WagePayments] Set Initial State'
);
